export default {
  "QUESTION": {
    "QUESTION": "Question",
    "QUESTIONS": "Questions"
  }
}



// WEBPACK FOOTER //
// ./src/i18n/messages/en/questions.js